export function truncate(str: string, len: number) {
  return str.length <= len ? str : str.slice(0, len) + '……'
}
